@if (deletingDocumentIds$ | async; as deletingIds) {
  @if (documents$ | async; as documents) {
    <table class="documents-table">
      <tbody>
        @for (doc of documents; track doc.id) {
          <tr>
            <td class="document-type">{{ getDocumentTypeLabel(doc.type) }}</td>
            <td class="document-filename">{{ doc.filename || '' }}</td>
            <td class="document-actions">
              @if (isDeleting(doc.id, deletingIds)) {
                <mat-progress-spinner diameter="24" mode="indeterminate"></mat-progress-spinner>
              } @else {
                <button mat-icon-button
                        (click)="deleteDocument(doc.id)"
                        matTooltip="Delete this document"
                        i18n-matTooltip>
                  <app-icon icon="delete"></app-icon>
                </button>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
}
